export const fetchWithTimeout = (url: string, timeout: number) => {
    return Promise.race([fetch(url), new Promise((_, reject) => setTimeout(() => reject(new Error("Время ожидания истекло")), timeout))]);
};
